// @flow strict

import type {TeamMemberAnalyticsData} from 'src/types/scheduler/dashboard.js';


export const SET_TEAM_MEMBER_ANALYTICS =
  'scheduler/dashboard/setTeamMemberAnalytics';

export type SetTeamMemberAnalyticsAction = {
  type: typeof SET_TEAM_MEMBER_ANALYTICS,
  payload: TeamMemberAnalyticsData[],
};

export type SchedulerDashboardActions = SetTeamMemberAnalyticsAction;

export const setTeamMemberAnalytics = (
  payload: TeamMemberAnalyticsData[],
): SetTeamMemberAnalyticsAction => ({
  type: SET_TEAM_MEMBER_ANALYTICS,
  payload,
});
